import React from 'react';
import PasswordResetForm from 'components/authentication/PasswordResetForm';
import { titler } from 'helpers/titler';

const PasswordReset = () => {
  titler('Reset Password');
  return (
    <div className="text-center">
      <h5>Reset Password</h5>
      <PasswordResetForm />
    </div>
  );
};

export default PasswordReset;
